// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequiredLabel_requiredLabel__2Bqob {
  font-size: 0.8rem;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/component/common/required-label/RequiredLabel.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,gBAAA;AACJ","sourcesContent":[".requiredLabel{\n    font-size: 0.8rem;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requiredLabel": `RequiredLabel_requiredLabel__2Bqob`
};
export default ___CSS_LOADER_EXPORT___;
